module.exports = __webpack_public_path__ + "static/media/logo.8bf126a3.png";